import PropTypes from 'prop-types';
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import { Col, Row } from "reactstrap";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import {
    crearOEditarSede,
    obtenerDatosCreacionSede,
} from "../../services/sedes-service";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { selectCiudades } from "../../../Personas/services/personas-service";
import { defaultValueSelect } from "../../../../core/helpers/form-helper";

const REQUIRED_RULE = { required: "Este campo es requerido" };

const FormSedes = ({ modalState, onSave }) => {
    const { sede } = modalState.data;
    const [selects, setSelects] = useState({
        departamentos: [],
        ciudades: [],
    });

    const defaultValues = {
        id: sede.id || "",
        nombre: sede.nombre || "",
        sigla: sede.sigla || "",
        indice: sede.indice ?? "",
        abreviatura: sede.abreviatura ?? "",
        email: sede.email || "",
        telefono: sede.telefono || "",
        ciudad_id:
            sede.ciudad != null
                ? { label: sede.ciudad.nombre, value: sede.ciudad.id }
                : "",
        departamento_id:
            sede.departamento != null
                ? {
                      label: sede.departamento.nombre,
                      value: sede.departamento.id,
                  }
                : "",
        direccion: sede.direccion || "",
        img: "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [sede]);

    const onCreateSede = async () => {
        const formData = new FormData(document.getElementById("formSede"));
        const resp = await crearOEditarSede(formData);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    const onChangeDepartamento = async (departamento) => {
        const resp = await selectCiudades(departamento.id);
        if (!resp.status) return toast.error(resp.message);

        const ciudades = resp.data.map((ciu) =>
            defaultValueSelect(ciu, "nombre", "id")
        );

        setSelects((selects) => ({ ...selects, ciudades }));
        form.setValue("ciudad_id", "");
    };

    useEffect(async () => {
        const resp = await obtenerDatosCreacionSede(sede.id);
        if (!resp.status) return toast.error(resp.message);

        const departamentos = resp.data.departamentos.map((dep) => {
            return { ...dep, label: dep.nombre, value: dep.id };
        });

        const ciudades = resp.data.ciudades.map((ciu) => {
            return { label: ciu.nombre, value: ciu.id };
        });

        setSelects({ departamentos, ciudades });
    }, [sede.id]);

    return (
        <FormModal
            size="lg"
            form={form}
            id="formSede"
            onSubmit={onCreateSede}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        name="nombre"
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Nombre"
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        name="sigla"
                        label="Sigla"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Sigla"
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        name="abreviatura"
                        label="Abreviatura"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Abreviatura"
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        errors={form.formState.errors}
                        name="direccion"
                        label="Dirección"
                        control={form.control}
                        rules={REQUIRED_RULE}
                        placeholder="Dirección"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        type="email"
                        name="email"
                        label="Correo"
                        placeholder="Correo"
                        control={form.control}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        type="tel"
                        name="telefono"
                        label="Teléfono"
                        control={form.control}
                        placeholder="Teléfono"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        id="img"
                        name="img"
                        type="file"
                        errors={form.formState.errors}
                        label="Imágen"
                        control={form.control}
                        placeholder="Imágen"
                        rules={sede.id == null ? REQUIRED_RULE : {}}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        name="departamento_id"
                        label="Departamento"
                        rules={REQUIRED_RULE}
                        onChange={onChangeDepartamento}
                        options={selects.departamentos}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        name="ciudad_id"
                        label="Ciudad"
                        rules={REQUIRED_RULE}
                        options={selects.ciudades}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        id="indice"
                        type="number"
                        name="indice"
                        label="Índice"
                        control={form.control}
                        placeholder="Índice"
                        rules={REQUIRED_RULE}
                        errors={form.formState.errors}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormSedes.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormSedes;
